import React from "react";
import PropTypes from "prop-types";
import { usePermissions } from "../../auth/hooks/usePermissions";

function Can({ permission, anyOf, allOf, fallback, children }) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = usePermissions();

  let isAllowed = true;

  if (permission) {
    isAllowed = hasPermission(permission);
  } else if (Array.isArray(anyOf) && anyOf.length > 0) {
    isAllowed = hasAnyPermission(anyOf);
  } else if (Array.isArray(allOf) && allOf.length > 0) {
    isAllowed = hasAllPermissions(allOf);
  }

  if (!isAllowed) return fallback;

  return <>{children}</>;
}

Can.propTypes = {
  permission: PropTypes.string,
  anyOf: PropTypes.arrayOf(PropTypes.string),
  allOf: PropTypes.arrayOf(PropTypes.string),
  fallback: PropTypes.node,
  children: PropTypes.node,
};

Can.defaultProps = {
  permission: "",
  anyOf: undefined,
  allOf: undefined,
  fallback: null,
  children: null,
};

export default Can;
